import request from '../utils/request';

// 添加运费模板
export function addFreightTemplate(data) {
  return request({
    url: '/freight-template',
    method: 'post',
    data: {
      name: data.name,
      isFreeShipping: data.isFreeShipping || 'NOT_FREE',
      freeCondition: data.freeCondition,
      defaultPrice: data.defaultPrice || 0.00
    }
  });
}

// 更新运费模板
export function updateFreightTemplate(data) {
  return request({
    url: `/freight-template/${data.id}`,
    method: 'put',
    data: {
      id: data.id,
      name: data.name,
      isFreeShipping: data.isFreeShipping,
      freeCondition: data.freeCondition,
      defaultPrice: data.defaultPrice
    }
  });
}

// 删除运费模板
export function deleteFreightTemplate(freightTemplateId) {
  return request({
    url: `/freight-template/${freightTemplateId}`,
    method: 'delete'
  });
}

// 分页查询运费模板
export function pageFreightTemplates(params) {
  return request({
    url: '/freight-template/page',
    method: 'get',
    params: {
      page: params.page || 1,
      pageSize: params.pageSize || 10,
      name: params.name,
      isFreeShipping: params.isFreeShipping,
      ...params
    }
  });
}

// 获取运费模板详情
export function getFreightTemplateDetail(freightTemplateId) {
  return request({
    url: `/freight-template/${freightTemplateId}`,
    method: 'get'
  });
}
